/*** IMPORTS FROM imports-loader ***/
var define = false;

import loadingIcon from '@SvgIcon/load-a.svg';

import $ from 'jquery';
import svgIconHtml from '../../../shared/svgIconHtml';
import { initializeProductDetail } from './functions';

function injectLoader($container) {
  $container.html(`
    <div style="margin: 2rem 0; text-align: center">
      <span class="product-detail-loading-icon rotating-and-pulsing">${svgIconHtml(loadingIcon)}</span>
    </div>
  `);
}

const $productModals = $('.product-detail-modal');
if ($productModals.length) {
  $productModals
    .on('open.zf.reveal', (ev) => {
      const $modal = $(ev.target);
      const $container = $modal.find('.product-detail-container');

      injectLoader($container);

      $.ajax({
        type: 'GET',
        url: $modal.data('href'),
      })
        .done((data) => {
          $container.html(data);
          const $product = $container.find('.product-detail');
          initializeProductDetail($product);
        })
        .fail(() => {
          $container.html('<p>There was a problem loading this product.');
        });
    });
}

